$(function() {
	const qs = document.querySelector.bind(document);
	const qsa = document.querySelectorAll.bind(document);
	
	// const nocache = Math.random();
	const nocache = 'false';
	
	const ratio = window.devicePixelRatio;
    let ratio_font_pixelate = .74;
	
	function renderPreview(preview_el, canvas, canvas_text) {
		/*
		let queue_resize = (selected_preview.size != rendered_preview.size);
		let queue_recolor = (selected_preview.color != rendered_preview.color);
		queue_recolor = true;
		let preview_clone;
		if (queue_recolor) {
		preview_clone =	$canvas_container.clone().addClass('clone');
		preview_clone.prependTo($preview);

		let clone_canvas = preview_clone.find('.preview-pattern');
		let clone_canvas_text = preview_clone.find('.preview-text');


	//			 clone_canvas[0].style.width = clone_canvas[0].offsetWidth;
	//			 clone_canvas_text[0].style.width = clone_canvas_text[0].offsetWidth;

	//			 clone_canvas[0].style.width = `${clone_canvas[0].offsetWidth}px;`;
	//			 clone_canvas_text[0].style.width = `${clone_canvas_text[0].offsetWidth}px;`;

		clone_canvas[0].style.width = `${clone_canvas[0].offsetWidth}px`;
		clone_canvas_text[0].style.width = `${clone_canvas_text[0].offsetWidth}px`;

		let clone_ctx = clone_canvas[0].getContext('2d');
		let clone_ctx_text = clone_canvas_text[0].getContext('2d');

		clone_ctx.drawImage(canvas, 0, 0);
		clone_ctx_text.drawImage(canvas_text, 0, 0);
		}
//			 $('.preview').clone().addClass('clone').appendTo('.preview-container');
		*/
		
		//set canvas size
		let new_w, new_h;
		
		/*
		portrait code -- unfinished, but dean appears to have no portrait designs to start
		if (design_matrix[selected_preview.design].orientation == 'landscape') {
		new_w = size_matrix[selected_preview.size].width * 4;
		new_h = size_matrix[selected_preview.size].height * 4;
		} else {
		new_w = size_matrix[selected_preview.size].height * 4;
		new_h = size_matrix[selected_preview.size].width * 4;
		}
		*/
		
		canvas.width = canvas.offsetWidth * ratio;
		canvas.height = canvas.offsetHeight * ratio;
		
        if (canvas.offsetWidth > 550) {
          ratio_font_pixelate = .74;
        } else if (canvas.offsetWidth > 450) {
          ratio_font_pixelate = .85;
        } else if (canvas.offsetWidth > 350) {
          ratio_font_pixelate = .95;
        } else {
          ratio_font_pixelate = 1;
        }
      
        canvas_text.width = canvas_text.offsetWidth * ratio_font_pixelate;
		canvas_text.height = canvas_text.offsetHeight * ratio_font_pixelate;
		//get contexts
		const ctx = canvas.getContext('2d');
		const ctx_text = canvas_text.getContext('2d');

		ctx.scale(ratio, ratio);
		ctx_text.scale(ratio_font_pixelate, ratio_font_pixelate);
		
		let cw = canvas.offsetWidth;
		let ch = canvas.offsetHeight;
		
		new_w = canvas.offsetWidth;
		new_h = canvas.offsetHeight;
		
		
		let pattern_url = `${theme_asset_dir}designer-${preview_el.dataset.design}-pattern-${preview_el.dataset.size}-${preview_el.dataset.color}-sm.png?nocache=${nocache}`;
        if (preview_el.dataset.design == 'classic-two-colour') pattern_url = `${theme_asset_dir}name-blanket-pattern-${preview_el.dataset.size}-${preview_el.dataset.color}-sm.png?nocache=${nocache}`;

		//load bg image, clear canvas, draw image
		let img = new Image();
		img.crossOrigin = 'anonymous';
		img.src = pattern_url;//"https://dl.dropboxusercontent.com/u/139992952/stackoverflow/house204-1.jpg";
		img.onload = function() {
			//set canvas size
			ctx.clearRect(0, 0, cw, ch); //clear vanvas //works, but flickers
			// ctx.fillRect(0, 0, new_w, new_h); //clear vanvas //works, but flickers
			// ctx.drawImage(img, 0, 0, new_w, new_h); //draw bg image
			// ctx.drawImage(img, (cw - new_w) / 2, (ch - new_h) / 2, new_w, new_h); //draw bg image
			
			ctx.drawImage(img, (cw - new_w) / 2, 0, new_w, new_h); //draw bg image
			
			//draw name, then do a few timeouts to redraw name, after fonts have loaded for sure
			drawText(preview_el, canvas, canvas_text);
			//add a timeout to try ensure preview fonts have loaded
			setTimeout(() => {
				drawText(preview_el, canvas, canvas_text); //draw name
			}, 1000);
			setTimeout(() => {
				drawText(preview_el, canvas, canvas_text); //draw name
			}, 3000);
			/*
			if (queue_resize) {
				$preview[0].classList.remove('resizing');
			}
			
			if (queue_recolor) {
				preview_clone.addClass('animate-out').delay(600).queue(function() {
				preview_clone.remove();
				});
			}
			*/
		}
	}
	
	function drawText(preview_el, canvas, canvas_text) {
		
		const ctx_text = canvas_text.getContext('2d');

        let selected_preview = preview_el.dataset;
        selected_preview.name = selected_preview.text;
        const font = fontMatrix[selected_preview.font];
        
		ctx_text.textAlign = 'center';
		// ctx_text.font = `bold ${design_matrix[selected_preview.design].font_size} ${design_matrix[selected_preview.design].font}`;
		ctx_text.font = `${design_matrix[preview_el.dataset.design].sizes[preview_el.dataset.size].font_size * canvas.offsetWidth / 100}px ${design_matrix[preview_el.dataset.design].font}`;
		
		let text_x = canvas.offsetWidth * design_matrix[preview_el.dataset.design].sizes[preview_el.dataset.size].text_x / 100;
		let text_y = canvas.offsetHeight * design_matrix[preview_el.dataset.design].sizes[preview_el.dataset.size].text_y / 100;

        //dynamic font size calculation for single name blankets
        
        let selectedFontMatrixParams;
        if (selected_preview.design == 'classic-two-colour') {
          // console.group('Variable Font Stuff');
          // console.log(design_matrix[selected_preview.design].responsive_sizes[selected_preview.size]['horizontal']);
          // console.log(selected_preview);
          
          //calculate best font size
          const selectedFont = selected_preview.font;
          const selectedOrientation = selected_preview.orientation;
          
          // console.log('selected_preview.font', selected_preview.font);
          // console.log('selected_preview.orientation', selected_preview.orientation);
          
          // const possibleFontSizes = design_matrix[selected_preview.design].responsive_sizes[selected_preview.size]['horizontal']['Quinty'];
          selectedFontMatrixParams = design_matrix[selected_preview.design].responsive_sizes[selected_preview.size][selected_preview.orientation][selected_preview.font];
          //const possibleFontSizes = design_matrix[selected_preview.design].responsive_sizes[selected_preview.size][selected_preview.orientation][selected_preview.font].font_size;
          const possibleFontSizes = selectedFontMatrixParams.font_size;
  
          const inputLength = selected_preview.name.length;
          let selectedFontSize = null;
          
          for (const key in possibleFontSizes) {
            if (key >= inputLength) {
              selectedFontSize = possibleFontSizes[key];
              break;
            }
          }
          if (selectedFontSize === null) selectedFontSize = possibleFontSizes[15];
          
          // console.log(selectedFontSize);
          // console.groupEnd();
          
          // ctx_text.font = `${design_matrix[selected_preview.design].sizes[selected_preview.size].font_size * canvas.offsetWidth / 100}px ${font}`;
          ctx_text.font = `${selectedFontSize * canvas.offsetWidth / 100}px ${font}`;
          
          // console.log('Draw text called: ', selected_preview.name, ` ${selectedFontSize * canvas.offsetWidth / 100}px ${font}`);
          
          // ctx_text.letterSpacing = '-0.05rem';
          ctx_text.letterSpacing = selectedFontMatrixParams.letterSpacing;
          
          // console.log('selectedFontMatrixParams', selectedFontMatrixParams);
          text_x = canvas.offsetWidth * selectedFontMatrixParams.text_x / 100;
          text_y = canvas.offsetHeight * selectedFontMatrixParams.text_y / 100;
        }
      
		ctx_text.clearRect(0, 0, canvas_text.offsetWidth, canvas_text.offsetHeight); //clear vanvas //works, but flickers
		
		/*if ('stroke_color' in design_matrix[selected_preview.design].colors[selected_preview.color]) {
		ctx_text.strokeStyle = design_matrix[selected_preview.design].colors[selected_preview.color].stroke_color;
		ctx_text.lineWidth = design_matrix[selected_preview.design].colors[selected_preview.color].stroke_width;
		ctx_text.strokeText(name, text_x, text_y);
		}*/

		//text color
		if (design_matrix[preview_el.dataset.design].darker_text_variants.includes(preview_el.dataset.color)) {
			// ctx_text.fillStyle = color_matrix_text_darker[design_matrix[preview_el.dataset.design].colors[preview_el.dataset.color].text_color];
			ctx_text.fillStyle = color_matrix_text_darker[preview_el.dataset.colorSecondary];
		} else {
			// ctx_text.fillStyle = color_matrix_text[design_matrix[preview_el.dataset.design].colors[preview_el.dataset.color].text_color];
			ctx_text.fillStyle = color_matrix_text[preview_el.dataset.colorSecondary];
			
		}
		
		// ctx_text.fillText(preview_el.dataset.text, text_x, text_y);


        // console.log(design_matrix[selected_preview.design].colors[selected_preview.color].text_color);
        ctx_text.textBaseline = (selected_preview.design == 'classic-two-colour') ? 'middle' : 'alphabetic';
        
        // ctx_text.fillText(selected_preview.name, text_x, text_y);
        // ctx_text.strokeText(selected_preview.name, text_x, text_y);
        
        let thicknessFactor = 0;
        let thickenFactorX = selectedFontMatrixParams?.thickenFactorX ?? 0;
        let thickenFactorY = selectedFontMatrixParams?.thickenFactorY ?? 0;
        
        let offsetStep = 0.1;
        
        // for (let dx = -thickenFactorX; dx <= thickenFactorX; dx += step) {
        //   for (let dy = -thickenFactorY; dy <= thickenFactorY; dy += step) {
        //     ctx_text.fillText(selected_preview.name, text_x + dx, text_y + dy);
        //   }
        // }
  
        // Draw the text with an outline in all directions
        //start with the provided offset in a negative value, and re-draw it by the step size, until we reach its positive value
        for (let offsetX = -thickenFactorX; offsetX <= thickenFactorX; offsetX += offsetStep) {
            for (let offsetY = -thickenFactorY; offsetY <= thickenFactorY; offsetY += offsetStep) {
                ctx_text.fillText(selected_preview.name, text_x + offsetX, text_y + offsetY);
            }
        }

      
		/*
				name_char_count.innerHTML = 15 - builder_fields.name.value.length;
				let selected_color = qs('input[name="color"]:checked').value;
				// let selected_design = qs('input[name="design"]').options[ qs('input[name="design"]').selectedIndex].value;
				// let field_design = qs('select[name="design"]');
				// console.log(field_design);
				let selected_design = builder_fields.design.options[builder_fields.design.selectedIndex].value;
				// select.options[select.selectedIndex].value
				let selected_size = qs('input[name="size"]:checked').value;
		
				// let name = qs('[name="name"]').value;
				let name = builder_fields.name.value;
				ctx_text.textAlign = 'center';
				// ctx.font = '48px serif';
				ctx_text.font = `bold ${design_matrix[selected_design].font_size} ${design_matrix[selected_design].font}`;
				// ctx.fillStyle = 'orange';
				// ctx.fillText('Hello world', 10, 50);
				let text_x = canvas.width * design_matrix[selected_design].sizes[selected_size].text_x / 100;
				let text_y = canvas.height * design_matrix[selected_design].sizes[selected_size].text_y / 100;
				// let text_y = 50;
		
				//clear canvas
				ctx_text.clearRect(0, 0, canvas_text.width, canvas_text.height); //clear vanvas //works, but flickers
		
				//maybe use stroke
				if ('stroke_color' in design_matrix[selected_design].colors[selected_color]) {
				ctx_text.strokeStyle = design_matrix[selected_design].colors[selected_color].stroke_color;
				ctx_text.lineWidth = design_matrix[selected_design].colors[selected_color].stroke_width;
				ctx_text.strokeText(name, text_x, text_y);
				}
		
				//text color
				ctx_text.fillStyle = design_matrix[selected_design].colors[selected_color].text_color;
		
				ctx_text.fillText(name, text_x, text_y);
				*/
	}
	
	$('.designer-blanket-preview-container').each(function(index, elem) {
		renderPreview(elem.querySelector('.preview'), elem.querySelector('.preview-pattern'), elem.querySelector('.preview-text'));
	});
});